import { useEffect } from 'react'

import { useApi } from '@tabeeb/modules/shared/utils/API'
import { useQuery } from '@tanstack/react-query'
import { AIQueryKeys } from '../queries'

const useVQAModel = ({ id, onError }: { id: number; onError: (error: unknown) => void }) => {
  const { aiServiceApi: api } = useApi()

  const { isLoading, data, error } = useQuery({
    queryKey: [AIQueryKeys.VQAModel, id],
    queryFn: () => api.vqaModels.getAsync(id),
  })

  useEffect(() => {
    if (error) onError(error)
  }, [error, onError])

  return { loading: isLoading, vqaModel: data }
}

export default useVQAModel
